import React, { useEffect, useState } from "react";
import RcPagination from "rc-pagination";
import localeInfo from "rc-pagination/lib/locale/en_US";
import "rc-pagination/assets/index.css";
import Sidebar from "../components/Sidebar";
import SearchHeader from "../components/SearchHeader";
import { Button, Table } from "reactstrap";
import Person from "../assets/img/account_circle_black_24dp.svg";
import { useLocation, useNavigate } from "react-router-dom";
import { doRequest, textItemRender } from "../utils/helper";

export default function DashboardNumberViewAll() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const count = queryParams.get("totalcount" || 0)
    ? queryParams.get("totalcount" || 0)
    : 0;
  const querytype = queryParams.get("type" || 0)
    ? queryParams.get("type" || 0)
    : 0;
  const [usersList, setUsersList] = useState({});
  const [filteredUsersList, setFilteredUsersList] = useState({});
  const [page, setPage] = useState("1");
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const limit = "20";

  const getUserData = async (type, page) => {
    try {

      let filter = ""; 

      if(type){
        filter = `&status=${type}`; 
      }

      if(type === "active"){
        filter = `&plan_status=active`; 
      }

      if(type === "inactive"){
        filter = `&plan_status=inactive`; 
      }

      if(type === "blocked"){
        filter = `&status=inactive`; 
      }

      let url = `user/list?page=${page ? page : "1"}${filter}&limit=${500}`;
      let response = await doRequest("", "GET", url);
      if (+response?.resultFlag === 1) {
        if (type === "active") {
          setUsersList(response?.response?.user);
        } else if (type === "inactive") {
          setUsersList(response?.response?.user);
        } else {
          setUsersList(response?.response?.user);
        }
      }
    } catch (error) {}
  };

  const getPlanData = async (id, page) => {
    try {
      let url = `user/list_usersby_blan?plan_id=${
        id ? id : ""
      }&limit=${limit}&page=${page ? page : "1"}`;
      let response = await doRequest("", "GET", url);
      if (+response?.resultFlag === 1) {
        if (+id === 6) {
          setUsersList(response?.response?.users);
        } else if (+id === 5) {
          setUsersList(response?.response?.users);
        } else if (+id === 1) {
          setUsersList(response?.response?.users);
        } else if (+id === 7) {
          setUsersList(response?.response?.users);
        }
      }
    } catch (error) {}
  };

  const callAllApi = async (page) => {
    if (querytype === "totaluser") {
      getUserData("", page);
    }
    if (querytype === "activeuser") {
      getUserData("active", page);
    }
    if (querytype === "inactiveuser") {
      getUserData("inactive", page);
    }
    if (querytype === "blockeduser") {
      getUserData("blocked", page);
    }
    if (querytype === "unlimitedplan") {
      getPlanData(6, page);
    }
    if (querytype === "payasplan") {
      getPlanData(5, page);
    }
    if (querytype === "freeplan") {
      getPlanData(1, page);
    }
    if (querytype === "yearlyplan") {
      getPlanData(7, page);
    }
  };

  // Search functionality across Name, Email, and Phone columns
  const handleSearch = (query) => {
    setSearchQuery(query);
    
    if (!query.trim()) {
      setFilteredUsersList(usersList);
      return;
    }

    const searchTerm = query.toLowerCase().trim();
    const filtered = usersList.filter((user) => {
      // Search in User Name (first_name + last_name)
      const fullName = `${user?.first_name || ""} ${user?.last_name || ""}`.toLowerCase();
      
      // Search in Email
      const email = (user?.email || "").toLowerCase();
      
      // Search in Phone
      const phone = (user?.phone || "").toLowerCase();
      
      return (
        fullName.includes(searchTerm) ||
        email.includes(searchTerm) ||
        phone.includes(searchTerm)
      );
    });
    
    setFilteredUsersList(filtered);
  };

  useEffect(() => {
    callAllApi(page);
  }, [location.search, page]);

  // Update filtered results when usersList changes
  useEffect(() => {
    setFilteredUsersList(usersList);
  }, [usersList]);
  console.log("usersList", usersList);
  return (
    <>
      <div className="container-fluid main">
        <Sidebar />
        <section className="home">
          <div className="container-fluid">
            <div className="searcmain_pad">
              <SearchHeader 
                placeHolder="Search by name, email, or phone..."
                search={searchQuery}
                onChangeHandler={handleSearch}
              />

              {/* Search Results Info */}
              {searchQuery && (
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <div className="search-results-info">
                    <span className="text-muted">
                      Found {filteredUsersList?.length || 0} users matching "{searchQuery}" in name, email, or phone
                    </span>
                  </div>
                  <button
                    className="btn btn-outline-secondary btn-sm"
                    onClick={() => {
                      setSearchQuery("");
                      setFilteredUsersList(usersList);
                    }}
                  >
                    Clear Search
                  </button>
                </div>
              )}

              <div className="table-responsive table_user_mar">
                <Table hover striped className="table_cust align-middle">
                  <thead className="thead_bg">
                    <th className="userth">User Name</th>
                    <th className="userth">Email</th>
                    <th className="userth">Phone</th>
                    <th className="userth">SUBSCRIPTION Plan</th>
                    <th className="userth">Status</th>
                    <th className="userth">Actions</th>
                  </thead>

                  <tbody>
                    {filteredUsersList?.length > 0 ? (
                      filteredUsersList?.map((item) => {
                        return (
                          <tr key={item?.id}>
                            <td>
                              <ul className="dasboar_table_list">
                                <li>
                                  <img
                                    src={
                                      item?.user_image
                                        ? item?.user_image
                                        : Person
                                    }
                                    alt=""
                                  />
                                </li>
                                <li>
                                  <h5>
                                    {(item?.first_name == null &&
                                      item?.last_name == null) ||
                                    (item?.first_name === "null" &&
                                      item?.last_name === "null") ||
                                    (item?.first_name === "" &&
                                      item?.last_name === "")
                                      ? "Profile"
                                      : `${item?.first_name} ${item?.last_name}`}
                                  </h5>
                                </li>
                              </ul>
                            </td>

                            <td>
                              {item?.email}
                            </td>

                            <td>
                              {item?.phone || "-"}
                            </td>

                            <td>
                              {item?.plan_status === "active" ? (
                                <h6 className="enable_t">Active</h6>
                              ) : (
                                <h6 className="expire_t">Expired</h6>
                              )}
                            </td>

                            <td>
                              <h6 className="enable_t">{item?.status}</h6>
                            </td>

                            <td>
                              <div className="viewProf_flex">
                                <Button
                                  tag="a"
                                  className="healcheck_user"
                                  onClick={() =>
                                    navigate(`/viewprofile/${item?.id}`, {
                                      state: "view",
                                    })
                                  }
                                >
                                  <img
                                    src={"/assets/images/eyepurple.svg"}
                                    className="healeyeblue"
                                    alt=""
                                  />
                                  <img
                                    src={"/assets/images/eyewhite.svg"}
                                    className="healeyewhite"
                                    alt=""
                                  />
                                  View Profile
                                </Button>

                                <Button
                                  onClick={() =>
                                    navigate(`/editprofile/${item?.id}`, {
                                      state: "edit",
                                    })
                                  }
                                  tag="a"
                                  className="edit_btn"
                                >
                                  <img
                                    src={"/assets/images/editpurple.svg"}
                                    className="healeyeblue"
                                    alt=""
                                  />
                                  <img
                                    src={"/assets/images/editwhite.svg"}
                                    className="healeyewhite"
                                    alt=""
                                  />
                                  Edit
                                </Button>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center py-4">
                          {searchQuery ? "No users found matching your search criteria." : "No users found."}
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </div>
              {/* Show pagination only when not searching or when search results are more than limit */}
              {(!searchQuery || (filteredUsersList?.length || 0) > parseInt(limit)) && (
                <div className="mt-2 p-4 d-flex justify-content-center">
                  <RcPagination
                    showSizeChanger
                    defaultPageSize={limit}
                    current={page}
                    total={searchQuery ? (filteredUsersList?.length || 0) : count}
                    locale={localeInfo}
                    itemRender={textItemRender}
                    onChange={(page) => {
                      setPage(page);
                    }}
                  />
                </div>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
